var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 65,
    rx: 16.5,
    fill: "#8927EF",
    stroke: "#ECEEF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19C7 15.134 10.134 12 14 12H52C55.866 12 59 15.134 59 19V47C59 50.866 55.866 54 52 54H14C10.134 54 7 50.866 7 47V19ZM14.284 48.5172H50.9899C53.437 47.7171 53.0291 44.8505 52.5193 43.5172C50.0722 37.5172 46.0618 38.3505 44.3624 39.5172C41.9834 41.6839 35.8997 43.9172 30.5977 35.5172C25.7036 25.9172 21.7611 27.5172 20.4017 29.5172C19.552 30.3505 17.037 33.7172 13.7742 40.5172C10.5115 47.3172 12.7546 48.6838 14.284 48.5172ZM48.2945 27C50.8285 27 52.8827 24.9853 52.8827 22.5C52.8827 20.0147 50.8285 18 48.2945 18C45.7605 18 43.7063 20.0147 43.7063 22.5C43.7063 24.9853 45.7605 27 48.2945 27Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.5a0cc9d5235df038bcb7e45232d98266.svg";
export { ForwardRef as ReactComponent };